import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import Stories from 'stories-react';
import { StoriesStyle } from './style';
import { UniversalDialog } from 'console/dialogs/universal';
import 'stories-react/dist/index.css';
import { memo, useCallback, useEffect, useRef, useState } from 'react';
import { useAction, useAppSelector } from 'shared/hooks/redux/hooks';
import { Typography } from '@mui/material';
import { change_stories_status } from 'entities/stories/utils/redux/stories-reducer';
import { useBox } from 'shared/hooks/utils';
export const ComponentStories = memo(function ComponentStories(props) {
    const { is_small_ui, open, close, request_error, response, loading_request, run, ids_stories, } = props;
    const changeStatusStory = useAction(change_stories_status);
    const newViewedIds = useRef([]);
    const [resStory, setResStory] = useState([]);
    const new_ids_stories = useAppSelector((state) => state.ui_stories_ids?.new_ids);
    const current_index = useRef(0);
    const boxedResponse = useBox(response);
    //для историй типа "component", для других типов надо переделывать
    const story = ids_stories.map((id_story) => {
        const findStory = boxedResponse.current?.ui_stories &&
            (resStory.length > 0 ? resStory : boxedResponse.current.ui_stories).find((elem) => elem._id === id_story);
        const component = () => {
            if (new_ids_stories?.find((el) => el === findStory?._id) &&
                !newViewedIds.current.find((el) => el === findStory?._id) &&
                findStory) {
                newViewedIds.current = [...newViewedIds.current, findStory._id];
            }
            return _jsx(Typography, { children: findStory?.content ?? '' });
        };
        return {
            type: 'component',
            component: component,
            duration: findStory?.duration,
        };
    });
    const handleStatus = useCallback(() => {
        if (newViewedIds.current.length > 0) {
            changeStatusStory(newViewedIds.current);
        }
        close();
    }, [newViewedIds]);
    const andStoryClose = useCallback(() => {
        setTimeout(() => {
            handleStatus();
        }, 500);
    }, []);
    const onStoryChange = useCallback((story_index) => {
        if (story_index == 1 &&
            story_index < ids_stories.length &&
            resStory.length == 0) {
            run({ id: ids_stories.slice(story_index + 1) });
            current_index.current = 1;
        }
    }, [resStory.length, ids_stories, current_index.current]);
    useEffect(() => {
        if (boxedResponse.current?.ui_stories && current_index.current !== 0) {
            setResStory((prevStory) => [
                ...prevStory,
                ...boxedResponse.current
                    .ui_stories,
            ]);
        }
    }, [boxedResponse.current?.ui_stories, current_index.current]);
    useEffect(() => {
        if (ids_stories) {
            run({ id: ids_stories.slice(0, 2) });
        }
        //для исправления ошибки пакета 'stories-react', не трогать
        document.body.addEventListener('touchstart', function (e) {
            e.stopPropagation();
        }, { capture: true, passive: false });
    }, []);
    return (_jsxs(UniversalDialog, { open: open, sx: StoriesStyle, onClose: handleStatus, children: [story &&
                (is_small_ui ? (_jsx(Stories, { stories: story, onAllStoriesEnd: andStoryClose, onStoryChange: onStoryChange })) : (_jsx(Stories, { stories: story, width: "900px", height: "600px", onAllStoriesEnd: andStoryClose, currentIndex: current_index.current, onStoryChange: onStoryChange }))), request_error && (_jsx(Typography, { variant: "subtitle1", color: "error", children: request_error }))] }));
});
